export default {
  errorsRootKey: 'invoice/family',
  resource: 'invoice/family',
  actions: ['index', 'create', 'show', 'update', 'destroy']
}
